import React from 'react';
import { Hero } from 'components/hero/Hero';
import { Divider } from 'components/elements/divider/Divider';

export const Component = () => {
  return (
    <>
      <Divider>Default</Divider>

      <Hero title="Hero title text" />

      <Divider>Title and tagline</Divider>

      <Hero tagline="Tagline" title="Hero title text" />

      <Divider>Title, tagline and text</Divider>

      <Hero
        tagline="Tagline"
        title="Hero title text"
        text={
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
            tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
            Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien enim,
            accumsan dictum blandit eu, dictum vel felis.
          </p>
        }
      />

      <Divider>Title, tagline, text, and button</Divider>

      <Hero
        tagline="Tagline"
        title="Hero title text"
        text={
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
            tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
            Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien enim,
            accumsan dictum blandit eu, dictum vel felis.
          </p>
        }
        link={{ href: 'https://kodo.is' }}
        linkText="Link text"
      />

      <Divider>Title, tagline, text, button and image</Divider>

      <Hero
        tagline="Tagline"
        title="Hero title text"
        text={
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
            tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
            Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien enim,
            accumsan dictum blandit eu, dictum vel felis.
          </p>
        }
        link={{ href: 'https://kodo.is' }}
        linkText="Link text"
        image={{ url: 'https://picsum.photos/id/983/1920/1080', width: 1920, height: 1080 }}
      />

      <Divider>Title, tagline, text, button, image and video</Divider>

      <Hero
        tagline="Tagline"
        title="Hero title text"
        text={
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
            tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
            Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien enim,
            accumsan dictum blandit eu, dictum vel felis.
          </p>
        }
        link={{ href: 'https://kodo.is' }}
        linkText="Link text"
        image={{ url: 'https://picsum.photos/id/983/1920/1080', width: 1920, height: 1080 }}
        video={{ href: '/static/video/black-particle-loop.mp4' }}
      />
    </>
  );
};
